import { Snackbar } from '@mui/material';

import { HideToastCallback, ToastOptions } from './types';

interface ToastProps {
    toast: ToastOptions;
    onHide: HideToastCallback;
    in?: boolean;
}

const DEFAULT_TOAST_DURATION = 5000;

export default function Toast(props: ToastProps) {
    return <Snackbar open={ props.in }
        onClose={ () => props.onHide(props.toast.id) }
        message={ props.toast.description }
        autoHideDuration={ props.toast.duration || DEFAULT_TOAST_DURATION }
        key={ props.toast.id }
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    />;
}
